export default __webpack_public_path__ + "655cfbe5cc720de8aa422fc0e33031ef.png";